export const errors = {
    required: 'Required',
    minLength: 'Please enter valid phone number',
    maxlength: 'Please enter valid phone number',
    invalid: 'Please enter valid phone number'
};
